import useAddCaseButton from "../../hooks/useAddCaseButton";
import SplitDropdownButton from "./SplitDropdownButton";

const wrapperClasses = "ml-2! whitespace-nowrap";

// sizes the menu to "Classic Intake" rather than to the button it hangs from
const menuClasses = "w-max!";

const addCaseLabel = <><i className="fa-solid fa-plus mr-2!"></i> Add Case</>;

const AddCaseButton = () => {
    const { isLoading, isOpen, toggle, menuItems, addCaseWithDefaultMode } = useAddCaseButton();

    return (
        <SplitDropdownButton
            variant="primary"
            isOpen={isOpen}
            onToggle={toggle}
            primaryLabel={addCaseLabel}
            onPrimaryAction={addCaseWithDefaultMode}
            loading={isLoading}
            loadingText="Loading"
            menuItems={menuItems}
            className={wrapperClasses}
            menuClassName={menuClasses}
        />
    );
};

export default AddCaseButton;
